import type { ConsumerAddressFields } from "@jti/evo-client";
import type { AddressStored, CasAddressStored } from "@jti/fe-common";

export const convertCasAddressToStoredAddress = (address: CasAddressStored | ConsumerAddressFields): AddressStored => {
  return {
    id: String(address.id),
    city: address?.city ?? "",
    streetName: Array.isArray(address.street) && address.street.length > 0 ? address.street[0] : "",
    streetNumber: Array.isArray(address.street) && address.street.length > 1 ? address.street[1] : "",
    streetAdditional: Array.isArray(address.street) && address.street.length > 2 ? address.street[2] : "",
    countryCode: address?.country_id ?? "",
    postcode: address.postcode ?? "",
    firstname: address.firstname ?? "",
    lastname: address.lastname ?? "",
    telephone: address.telephone ?? "",
    isDefaultBilling: address.default_billing,
    isDefaultShipping: address.default_shipping,
    provinceName: address.administrative_area_level_2 ?? "",
    districtName: address.sublocality_level_2 ?? "",
    isSubscription: Boolean(address?.extension_attributes?.subscription),
    district: address.district ?? "",
    buildingNumber: address.building_number ?? "",
    neighborhood: address.neighborhood ?? "",
    premise: address.premise ?? "",
    landmark: address.landmark ?? "",
    shortAddress: address.short_address ?? "",
    regionCode: address?.region?.region_code ?? "",
    region: address?.region,
  };
};
